export default {
  links: {
    whatsapp: 'https://maternidade.auxiliomaternidadeoficial.com.br/redirecionar'
  }
}
